import { FC, memo } from 'react'
import styled, { css } from 'styled-components'
import CloseIcon from 'svgIcons/Close'

export type TDrawSelectedItemInfo = {
  id: string
  label: string
}

interface IFDrawSelectedItemProps {
  selectedItem: TDrawSelectedItemInfo
  onDelete: (selectedItemId: string) => void
  className?: string
}

const DrawSelectedItem: FC<IFDrawSelectedItemProps> = ({
  selectedItem,
  onDelete,
  className,
}) => {
  const { id, label } = selectedItem

  const handleCloseClick = () => {
    onDelete(id)
  }

  return (
    <StyledWrapper className={className}>
      <div className="item-content">{label}</div>
      <CloseIcon onClick={handleCloseClick} className="close-icon" />
    </StyledWrapper>
  )
}

export default memo(DrawSelectedItem, (prev, next) => {
  return (
    prev.selectedItem === next.selectedItem && prev.onDelete === next.onDelete
  )
})

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    transition: all 0.1s ease-in-out;
    align-items: center;
    font-size: 12px;
    font-weight: normal;
    padding: 8px 15px;
    border: 1px solid #d9e9f3;
    border-radius: 5px;
    background-color: ${theme.background.bg_4};
    color: ${theme.color.text_1};

    .close-icon {
      width: 10px;
      height: 10px;
      margin-left: 10px;
      :hover {
        cursor: pointer;
      }
    }
  `}
`
